module.exports = __webpack_public_path__ + "img/university-header-right-texture.0e9b512e.svg";